import { Alert, type AlertProps, AlertIcon } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { TFunction } from "i18next";
import type { DoffinNoAnswer } from "./doffinNoAnswer";

export const DoffinNoAnswerAlert = ({
  noAnswer,
  ...alertProps
}: { noAnswer: DoffinNoAnswer } & AlertProps) => {
  const { t } = useTranslation();
  return (
    <Alert status={noAnswer === "nothingSent" ? "error" : "warning"} alignItems="start" {...alertProps}>
      <AlertIcon />
      {noAnswerText(noAnswer, t)}
    </Alert>
  );
};

export const noAnswerText = (noAnswer: DoffinNoAnswer, t: TFunction): string =>
  ({
    whileSending: t("zz_DoffinApiErrorCode_DoffinDidNotAnswerWhileSending"),
    nothingSent: t("zz_DoffinApiErrorCode_DoffinDidNotAnswerNothingSent"),
    waitingForDoffin: t("zz_DoffinApiErrorCode_NoticeWaitingForDoffin"),
  })[noAnswer];
